/**
 * Returns a string where the prefix is wrapped in a <strong> tag, followed by the number.
 * Optionally highlights the prefix (first 2 characters) in <strong>.
 * If either argument is missing, returns an empty string.
 *
 * @param {string|number} sealNumber - Full seal number.
 * @param {boolean} shouldHighlightSealPrefix - Whether to highlight the prefix.
 * @returns {string} Formatted string with prefix in <strong> and number after.
 */
export default function sealNumber(sealNumber, shouldHighlightSealPrefix = false) {
    if (!sealNumber) return '---'

    const value = String(sealNumber)

    if (!shouldHighlightSealPrefix || value.length < 2) return value

    return `<strong>${value.slice(0, 2)}</strong>${value.slice(2)}`
}